angular.module('webtrader').controller('Main', ($rootScope, $log) => {
  $rootScope.BASE_URL = BASE_URL
  $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
    event.preventDefault();
    $log.info(event, toState, toParams, fromState, fromParams, error)
  });
})
